import React, { useCallback, useEffect, useRef, useState } from "react";
import { Checkbox, Col, Modal, Row } from 'antd';

import { BASE_URL,AddStaff, UploadFile, FetchDepartment, FetchDesignation, FetchShifts, FetchLocation, STAFF_ROLE, FetchStaff, UpdateStaff } from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { CameraOutlined } from "@ant-design/icons";
import moment from "moment";
import { useSelector } from "react-redux";
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css'
const HeadStaffModel = ({ open, onCancel,isAttendanceHead}) => {
  const [staffDetail, setStaffDetail] = useState([])
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const userInfo = useSelector((state) => state.signUp.signUpDetails);

  const capitalizeFirstLetter = (str) => {
    return str?.replace(/\b\w/g, (char) => char.toUpperCase());
  };
  const gridOptions = {
    getRowClass: params => {
        if (params.node.rowIndex % 2 !== 0) {
            return 'RowColor';
        }
    },

}
const onFilterTextBoxChanged = useCallback(() => {
    gridRef.current.api.setGridOption(
      'quickFilterText',
      document.getElementById('filter-text-box').value
    );
  }, []);
    useEffect(() => {
        getStaffList();
      
      }, []);
   
      const getStaffList = async () =>{
        const token = localStorage.getItem('authToken');
        try{
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchStaff}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({roles : [STAFF_ROLE.All]}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeStaff = data.data.filter(item => item.isActive);
               setStaffDetail(activeStaff)
              
              } else {
                const data = await response.json();
                console.log('stafferr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
          } catch (error) {
            console.error('Error updating designation:', error);
        }
      }

      const columnDefs = [{
        headerName: 'Profile',
        field:'profile',
        
        flex: 1,
        cellRenderer: (params) => {
            return(
            <>
          <div className=''>
            <div className="flex items-center">
              <div>
                {console.log("--------------->",params.data.item)}
                <img
                  className='hisimage min-w-[47px] min-h-[47px] w-[47px] h-[47px] rounded-full'
                  src={params?.data?.item?.faceRegisterUrl}
                  alt=''
                />
              </div>
              <div className='pl-[12px]'>
                <p className='text-base !font-sbold'>{capitalizeFirstLetter(params.data.item.firstName)}</p>
                <p className="text-sm">{capitalizeFirstLetter(params.data.item.designation.designationName)}</p>
              </div>
            </div>
          </div>
          </>
            )
            },
      },
      {
        headerName: 'Add',
        field:'add',
        flex: 1,
        cellRenderer: (params) => {
          console.log('headStaffModel',params.data)
            return(
          <Checkbox
            className='assign-att-take mt-0'
            style={{fontSize: "14px",
                fontWeight: "700"}}
            // checked={params.data?.item?.isInList}
            checked={isAttendanceHead ? 
                params?.data?.item?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.AttendanceHeads) 
            : params?.data?.item?.staffRole?.some(role => role.uniqueId === STAFF_ROLE.EmployeeHeads)}

            onChange={(e) => handleCheckboxChange(params?.data?.item, 'attendance_heads', e.target.checked)}
          >
            
          </Checkbox>
        )
       }
      },
      
    ];

         const data = staffDetail?.filter(item => item?.isStaffBo !== true).map((item, index) => {   
            return {
              key: index,
              item: item,
              profile: item.firstName,
            };
          
          });

        
        const handleCheckboxChange = (params, field, checked) => {
            console.log('params', params);
            console.log('checked', checked);
            const storedData = userInfo?.availableRoles;
            let objectWithUniqueId1 = '';
           if(isAttendanceHead){

                objectWithUniqueId1 = storedData?.find(item => item.uniqueId === STAFF_ROLE.AttendanceHeads);
            }else{
                objectWithUniqueId1 = storedData?.find(item => item.uniqueId === STAFF_ROLE.EmployeeHeads);

            }
        
            if (objectWithUniqueId1) {
                const roleIdToCheck = objectWithUniqueId1.roleId;
                const roleIds = params.staffRole.map(role => role.roleId); // Extracting roleIds
console.log('roleIds',roleIds)
        if (roleIds.includes(roleIdToCheck) && !checked) {
            // Remove the roleId from staffRole array
            const updatedRoleIds = roleIds.filter(roleId => roleId !== roleIdToCheck);
            updateStaff(updatedRoleIds, params._id);
                    console.log('updatedStaffRole',updatedRoleIds)
                } else if (!roleIds.includes(roleIdToCheck) && checked) {
                    
                    const updatedRoleIds = [...roleIds, roleIdToCheck];
                    updateStaff(updatedRoleIds, params._id);
                    console.log('updatedStaffRole1',updatedRoleIds)
                }
            }
        };

         const updateStaff = async (updatedRoleIds,staffRoleId) => {
            const token = localStorage.getItem('authToken');
            const data = {
              _id : staffRoleId,
              staffRole : updatedRoleIds
              // staffRole : ["48e9571e-2b04-4a34-983f-7ffe9b5a2e18"]
            }
          console.log('data',data)
            try{
                const fetchData = async () => {
                  const response = await fetch(`${BASE_URL}/${UpdateStaff}`, {
                    method: "POST",
                     headers: {
                              'Content-Type': 'application/json',
                              'Authorization': `${token}`,
                              
                            },
                    body: JSON.stringify(data),
                  });
                  
                  if (response.ok) {
                    const data = await response.json();
                    console.log('data',data)
                     getStaffList()
                  } else {
                    const data = await response.json();
                    console.log('stafferr',data)
                    toast.error(data.errorMessage, {
                      position: toast.POSITION.TOP_RIGHT,
                    });
                    
                  }
                };
                await fetchData();
              } catch (error) {
                console.error('Error updating designation:', error);
            }
        }
  return (
    <Modal
      title="Staff"
      open={open}
      okButtonProps={{ style: { background: "grey" } }}
      onCancel={onCancel}
      footer={null}
    >
     <ToastContainer position="top-right" autoClose={2000} />
     <input
                            type="text"
                            id="filter-text-box"
                            className="border-bottom w-full text-base mx-2 outline-none"
                            placeholder="Search..."
                            onInput={onFilterTextBoxChanged}
                          />
     <div className='ag-theme-alpine text-base footer-12 border-none font-proxima' style={{  width: '100%', marginTop: '10px' }}>
     <AgGridReact
       ref={gridRef}
       gridOptions={gridOptions}
        columnDefs={columnDefs}
        rowData={data}
        domLayout='autoHeight'
        onGridReady={(params) => setGridApi(params.api)}
        pagination={true}
        getRowHeight={() => 60}
        paginationPageSize={20}
        paginationPageSizeSelector={false}
      />
    </div>
     
    </Modal>
  );
};

export default HeadStaffModel;
